import styled from 'styled-components';
import { Form } from '@unform/web';

export const Wrapper = styled(Form)`
  display: flex;
  flex-direction: column;

  width: 100%;

  p.Mui-error {
    margin-top: 0;
  }
`;
